<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import Toast from 'primevue/toast'
import ConfirmDialog from 'primevue/confirmdialog'
import Button from 'primevue/button'
import { usarSesion } from '@/stores/guion'
import { api, token } from '@/api/cliente'

const sesion = usarSesion()
const router = useRouter()
const oscuro = ref(localStorage.getItem('botia.oscuro') === '1')

function alternarTema() {
  oscuro.value = !oscuro.value
  document.documentElement.classList.toggle('oscuro', oscuro.value)
  localStorage.setItem('botia.oscuro', oscuro.value ? '1' : '0')
}

async function salir() {
  // Se revoca en el SERVIDOR antes de olvidarlo aquí. Borrarlo solo del
  // navegador deja el token vivo una semana entera para quien lo tenga copiado
  // de antes, que es justo de lo que uno se quiere proteger al pulsar "salir".
  //
  // Si la llamada falla igual se sale: dejar a alguien atrapado dentro porque
  // la red se cayó sería peor. Queda vivo hasta que caduque.
  try { await api.salir() } catch { /* se sale igual */ }
  token.olvidar()
  sesion.salir()
  router.push('/entrar')
}

onMounted(() => {
  document.documentElement.classList.toggle('oscuro', oscuro.value)
})
</script>

<template>
  <div class="app">
    <header v-if="sesion.autenticado" class="barra">
      <span class="marca">Guiones del bot</span>
      <Button label="Tenants" text size="small" icon="pi pi-list" @click="router.push('/')" />
      <Button label="Acceso" text size="small" icon="pi pi-users" @click="router.push('/usuarios')"
              v-tooltip.bottom="'Quién puede entrar a la consola y qué sesiones hay abiertas'" />
      <span class="espacio" />
      <span class="tenue pequeno">{{ sesion.usuario?.nombre || sesion.usuario?.username }}</span>
      <!-- La versión del servidor, no la del navegador. Ya hubo dos veces en
           que "no me aparece X" resultó ser un binario sin actualizar y el
           código estaba bien; esto lo responde de un vistazo. -->
      <span v-if="sesion.usuario?.version" class="tenue pequeno mono"
            title="Versión del servidor que atiende esta consola">
        {{ sesion.usuario.version }}
      </span>
      <Button :icon="oscuro ? 'pi pi-sun' : 'pi pi-moon'" text rounded size="small"
              v-tooltip.bottom="'Cambiar tema'" @click="alternarTema" />
      <Button icon="pi pi-sign-out" text rounded size="small"
              v-tooltip.bottom="'Salir'" @click="salir" />
    </header>

    <main class="contenido">
      <RouterView />
    </main>

    <Toast position="bottom-right" />
    <ConfirmDialog />
  </div>
</template>
